import React, {Component} from 'react';
import {Header} from 'semantic-ui-react';
import {FormattedNumber} from "react-intl";

class SaleTotal extends Component {
    render(){
        return(
            <span>
                <Header as='h4' style={{margin:'0px'}}>Total Venta: $
                            <FormattedNumber
                                value={this.props.total.total_sale}
                                currency="USD"
                                maximumFractionDigits={0}
                                minimumFractionDigits={0}
                            />
                        </Header>
                {this.props.state !== 2 && this.props.total.balance !== 0 ?
                    <Header as='h4' style={{margin:'0px'}} color='orange'>Saldo: $
                        <FormattedNumber
                            value={this.props.total.balance}
                            currency="USD"
                            maximumFractionDigits={0}
                            minimumFractionDigits={0}
                        />
                    </Header>:null
                }
            </span>
        )
    }
}
export default SaleTotal;


// WEBPACK FOOTER //
// ./src/components/sales/SaleTotal.js